import type { FunctionComponent } from 'react';
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAuth } from 'react-oidc-context';
import { useDispatch, useSelector } from 'react-redux';

import cross from '../../../../assets/logo/cross.svg';
import smallLogo from '../../../../assets/logo/logo.png';
import menu from '../../../../assets/logo/menu.svg';
import { isInApp } from '../../../main/util/is-app';
import { Button, ButtonSize } from '../../../shared/components/button/button';
import { ImageLogo } from '../../../shared/components/image-logo/image-logo.';
import { useContextNavigate } from '../../../shared/hooks/use-context-navigate';
import { useFullPath } from '../../../shared/hooks/use-full-location';
import { useSignIn } from '../../../shared/hooks/use-sign-in';
import { layoutStore, selectIsMainMenuOpen } from '../../../shared/store/layout.store';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';

import styles from './compact-navigation-bar.module.scss';

const style = createStyleHelper(styles, 'compact-navigation-bar');

export interface ICompactNavigationBarProps {
    className?: string;
    onClose?: () => void;
    title?: any;
}

export const CompactNavigationBar: FunctionComponent<ICompactNavigationBarProps> = ({
    className,

}) => {
    const returnPath = useFullPath();
    const isNativeApp = isInApp();
    const auth = useAuth();
    const navigate = useContextNavigate();
    const signIn = useSignIn();


    const isMenuOpen = useSelector(selectIsMainMenuOpen);
    const dispatch = useDispatch();

    const toggleMenu = useCallback(
        () => dispatch(layoutStore.actions.toggleMainMenu()),
        [dispatch],
    );



    return (
        <nav className={createClassName([className, style('')])}>
            <div className={style('button-group')}>
                <div onClick={toggleMenu}>
                    {isMenuOpen ? (
                        <ImageLogo className={style('menu')} srcPath={cross} />
                    ) : (
                        <ImageLogo className={style('menu')} srcPath={menu} />
                    )}{' '}
                </div>
                <div>
                    <ImageLogo className={style('logo')} srcPath={smallLogo} />
                </div>
            </div>

            {!isNativeApp ? (
                !auth.isAuthenticated && !auth?.user ? (
                    <div className={style('button-group')}>
                        <Button
                            className={style('login')}
                            size={ButtonSize.MEDIUM}
                            hollow
                            light
                            onClick={signIn}
                        >
                            <FormattedMessage id="top-navigation.login" defaultMessage="LOGIN" />
                        </Button>
                        <Button
                            className={style('signup')}
                            size={ButtonSize.MEDIUM}
                            onClick={() => navigate('/registration')}
                        >
                            <FormattedMessage id="top-navigation.signup" defaultMessage="SIGNUP" />
                        </Button>
                    </div>
                ) : (
                    <div className={style('button-group')}>
                        <Button
                            className={style('logout')}
                            hollow
                            light
                            size={ButtonSize.SMALL}
                            href={`/logout?backTo=${returnPath}`}
                        >
                            <FormattedMessage
                                id="compact-navigation.cta.logout"
                                defaultMessage="Logout"
                            />
                        </Button>
                    </div>
                )
            ) : null}
        </nav>
    );
};
